import { Form, Input, Modal, ModalProps, Select } from "antd"
import { createRoot } from "react-dom/client"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { useEffect } from "react"
import {  createReactionSet, updateReactionSet } from "@/services/admin/property-set"
import { ReactionsEditor } from "./ReactionsEditor"

interface AddEditReactionSetProps extends ModalProps {
  onSuccess?: () => void
  reactionSet?: PropertySetModule.Reaction
  propertySet: PropertySetModule.Modal
}

export function AddEditReactionSet(props: AddEditReactionSetProps)  {
  const { reactionSet, onSuccess, onCancel, propertySet } = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (reactionSet) {
      form.setFieldsValue(reactionSet)
    }
  })

  const handleCancel = (e?) => {
    onCancel?.(e)
    form.resetFields()
  }

  const save = async (values) => {
    if (!reactionSet) {
      await createReactionSet(values, { setId: propertySet.id })
    } else {
      await updateReactionSet(values, { setId: propertySet.id, id: reactionSet.id })
    }
    onSuccess?.()
  }

  if (!propertySet) return null

  return <Modal
    {...props}
    width={900}
    open={true}
    maskClosable={false}
    onCancel={handleCancel}
    onOk={() => form.submit()}
  >
    <div>Add Reaction Set</div>
    <Form
      form={form}
      onFinish={(values) => {
        save(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter reaction name' }]}>
        <Input type='text' style={{width: 300}} />
      </Form.Item>

      <Form.Item label='Reactions' name='reactions'>
        <ReactionsEditor propertySet={propertySet} />
      </Form.Item>
      
    </Form>
  </Modal>
}

AddEditReactionSet.show = (props: AddEditReactionSetProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddEditReactionSet
    {...props}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
  />);
}